import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { fetchConvertStatusSuccess } from '../actions/ConvertStatus';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

// recent convertStatus
const getConvertStatus = async (letterCode: string) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`LetterBody/IsConvertPending?letterCode=${letterCode}`);
};

function* fetchConvertStatusRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedConvertStatus = yield call(getConvertStatus, action.payload);
    yield put(fetchConvertStatusSuccess(fetchedConvertStatus.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchConvertStatus() {
  yield takeEvery(ActionTypes.GET_CONVERTSTATUS, fetchConvertStatusRequest);
}

// For New Details
export default function* rootSaga() {
  yield all([fork(fetchConvertStatus)]);
}
